import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IFilterAngularComp } from 'ag-grid-angular';
import { AgPromise, IFilterParams } from 'ag-grid-enterprise';

@Component({
  selector: 'app-dropdown-filter',
  imports: [ReactiveFormsModule],
  templateUrl: './dropdown-filter.component.html',
  styleUrl: './dropdown-filter.component.scss',
})
export class DropdownFilterComponent implements IFilterAngularComp {
  private value: string | null | undefined;

  isFilterActive(): boolean {
    return true;
  }
  getModel() {
    if (!this.isFilterActive()) {
      return null;
    }
    return this.value === null || this.value === undefined
      ? null
      : { filter: this.value };
  }
  setModel(model: unknown): void | AgPromise<void> {
    if (
      model &&
      typeof model === 'object' &&
      'filter' in model &&
      (typeof model.filter === 'string' ||
        model.filter === null ||
        model.filter === undefined)
    ) {
      this.value = model.filter;
    }
  }
  doesFilterPass(): boolean {
    return true;
  }
  params!: IFilterParams;

  agInit(params: IFilterParams): void {
    this.params = params;
  }

  onFloatingFilterChanged(type: string | null, value: string | null) {
    this.value = value;
    this.params.filterChangedCallback();
  }
}
